/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */
import { useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  ExportMonitoringEntriesQueryControllerExportParams,
  ListMonitoringEntriesQueryControllerListParams,
  ListMonitoringEntriesResponseDto,
} from "../model";

import { axiosClient } from "../../lib/api";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * Unified projection over fridge out-of-range incidents, hot-holding alerts, failed pass/fail checks and threshold-bearing readings. scope=alerts returns open alert episodes only; scope=resolved-alerts returns the episodes closed within the date window, with who resolved them and when; scope=history returns every reading in the date window (defaulting to the current month), plus monitored pass/fail checks, plus untargeted records — garden welfare checks, sleep checks, food temperatures and fire drills, which carry no target and so no verdict. History rows also name who performed the check. Filterable by log type, check slug, location and status; sortable by any column; paginated.
 * @summary List monitoring entries for a nursery (Monitoring page)
 */
export const listMonitoringEntriesQueryControllerList = (
  nurseryId: string,
  params?: ListMonitoringEntriesQueryControllerListParams,
  signal?: AbortSignal,
) => {
  return axiosClient<ListMonitoringEntriesResponseDto>({
    url: `/v1/nurseries/${nurseryId}/monitoring/entries`,
    method: "GET",
    params,
    signal,
  });
};

export const getListMonitoringEntriesQueryControllerListQueryKey = (
  nurseryId: string,
  params?: ListMonitoringEntriesQueryControllerListParams,
) => {
  return [
    `/v1/nurseries/${nurseryId}/monitoring/entries`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListMonitoringEntriesQueryControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof listMonitoringEntriesQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  params?: ListMonitoringEntriesQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listMonitoringEntriesQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListMonitoringEntriesQueryControllerListQueryKey(nurseryId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listMonitoringEntriesQueryControllerList>>
  > = ({ signal }) =>
    listMonitoringEntriesQueryControllerList(nurseryId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: nurseryId !== null && nurseryId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listMonitoringEntriesQueryControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListMonitoringEntriesQueryControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMonitoringEntriesQueryControllerList>>
>;
export type ListMonitoringEntriesQueryControllerListQueryError = void;

export function useListMonitoringEntriesQueryControllerList<
  TData = Awaited<ReturnType<typeof listMonitoringEntriesQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  params: undefined | ListMonitoringEntriesQueryControllerListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listMonitoringEntriesQueryControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMonitoringEntriesQueryControllerList>>,
          TError,
          Awaited<ReturnType<typeof listMonitoringEntriesQueryControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListMonitoringEntriesQueryControllerList<
  TData = Awaited<ReturnType<typeof listMonitoringEntriesQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  params?: ListMonitoringEntriesQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listMonitoringEntriesQueryControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMonitoringEntriesQueryControllerList>>,
          TError,
          Awaited<ReturnType<typeof listMonitoringEntriesQueryControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListMonitoringEntriesQueryControllerList<
  TData = Awaited<ReturnType<typeof listMonitoringEntriesQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  params?: ListMonitoringEntriesQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listMonitoringEntriesQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List monitoring entries for a nursery (Monitoring page)
 */

export function useListMonitoringEntriesQueryControllerList<
  TData = Awaited<ReturnType<typeof listMonitoringEntriesQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  params?: ListMonitoringEntriesQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listMonitoringEntriesQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListMonitoringEntriesQueryControllerListQueryOptions(
    nurseryId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * The same projection and the same filters as the list endpoint, returned as a CSV attachment covering the whole filtered set rather than one page. AC24 is this endpoint; AC14 is this endpoint with `checkSlug=emergency-light-flick-test` or `emergency-light-visual-check`. Rejects a request that would exceed 10,000 rows rather than truncating, so an export is never a silent half-record. Each row carries the corrective actions raised against it, with their status and recorded outcome.
 * @summary Export monitoring records as CSV
 */
export const exportMonitoringEntriesQueryControllerExport = (
  nurseryId: string,
  params?: ExportMonitoringEntriesQueryControllerExportParams,
  signal?: AbortSignal,
) => {
  return axiosClient<Blob>({
    url: `/v1/nurseries/${nurseryId}/monitoring/entries/export`,
    method: "GET",
    params,
    responseType: "blob",
    signal,
  });
};

export const getExportMonitoringEntriesQueryControllerExportQueryKey = (
  nurseryId: string,
  params?: ExportMonitoringEntriesQueryControllerExportParams,
) => {
  return [
    `/v1/nurseries/${nurseryId}/monitoring/entries/export`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExportMonitoringEntriesQueryControllerExportQueryOptions = <
  TData = Awaited<
    ReturnType<typeof exportMonitoringEntriesQueryControllerExport>
  >,
  TError = void,
>(
  nurseryId: string,
  params?: ExportMonitoringEntriesQueryControllerExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof exportMonitoringEntriesQueryControllerExport>
        >,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getExportMonitoringEntriesQueryControllerExportQueryKey(nurseryId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof exportMonitoringEntriesQueryControllerExport>>
  > = ({ signal }) =>
    exportMonitoringEntriesQueryControllerExport(nurseryId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: nurseryId !== null && nurseryId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof exportMonitoringEntriesQueryControllerExport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExportMonitoringEntriesQueryControllerExportQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof exportMonitoringEntriesQueryControllerExport>>
  >;
export type ExportMonitoringEntriesQueryControllerExportQueryError = void;

export function useExportMonitoringEntriesQueryControllerExport<
  TData = Awaited<
    ReturnType<typeof exportMonitoringEntriesQueryControllerExport>
  >,
  TError = void,
>(
  nurseryId: string,
  params: undefined | ExportMonitoringEntriesQueryControllerExportParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof exportMonitoringEntriesQueryControllerExport>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof exportMonitoringEntriesQueryControllerExport>
          >,
          TError,
          Awaited<
            ReturnType<typeof exportMonitoringEntriesQueryControllerExport>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExportMonitoringEntriesQueryControllerExport<
  TData = Awaited<
    ReturnType<typeof exportMonitoringEntriesQueryControllerExport>
  >,
  TError = void,
>(
  nurseryId: string,
  params?: ExportMonitoringEntriesQueryControllerExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof exportMonitoringEntriesQueryControllerExport>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof exportMonitoringEntriesQueryControllerExport>
          >,
          TError,
          Awaited<
            ReturnType<typeof exportMonitoringEntriesQueryControllerExport>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExportMonitoringEntriesQueryControllerExport<
  TData = Awaited<
    ReturnType<typeof exportMonitoringEntriesQueryControllerExport>
  >,
  TError = void,
>(
  nurseryId: string,
  params?: ExportMonitoringEntriesQueryControllerExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof exportMonitoringEntriesQueryControllerExport>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Export monitoring records as CSV
 */

export function useExportMonitoringEntriesQueryControllerExport<
  TData = Awaited<
    ReturnType<typeof exportMonitoringEntriesQueryControllerExport>
  >,
  TError = void,
>(
  nurseryId: string,
  params?: ExportMonitoringEntriesQueryControllerExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof exportMonitoringEntriesQueryControllerExport>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getExportMonitoringEntriesQueryControllerExportQueryOptions(
      nurseryId,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
